import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "register-form"
};
const _hoisted_2 = {
  class: "form-popup"
};
const _hoisted_3 = {
  class: "popup-main"
};
const _hoisted_4 = {
  class: "popup-header"
};
const _hoisted_5 = {
  class: "popup-content"
};
const _hoisted_6 = {
  class: "input-row"
};
const _hoisted_7 = {
  class: "input-box width-auto"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "input-text"
}, "+63", -1);
const _hoisted_9 = {
  class: "input-box"
};
const _hoisted_10 = {
  class: "input-row"
};
const _hoisted_11 = {
  class: "input-box"
};
const _hoisted_12 = {
  class: "suffix-wrap"
};
const _hoisted_13 = {
  class: "input-row"
};
const _hoisted_14 = {
  class: "input-box"
};
const _hoisted_15 = {
  key: 1,
  class: "sms-btn disabled"
};
import { ref, reactive, computed, inject, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import md5 from 'js-md5';
import moment from 'moment';
import ws from '@/connect';
import { useFBQ } from '@/hooks';
import { useUserStore } from '@/store';
import UploadId from './UploadId';
import DateSelect from '@/components/Common/DateSelect.vue';
import { register, registerOTP } from "@/api";
export default {
  __name: 'Register',
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const MyToast = inject('myToast');
    const {
      t
    } = useI18n();
    const router = useRouter();
    const userStore = useUserStore();
    const form = reactive({
      phone: '',
      password: '',
      verifyCode: '',
      fullName: '',
      birthdayTimestamp: '',
      selfieImg: ''
    });
    const showPassword = ref(false);
    const coldDownTime = ref(0);
    const coldDownInterval = ref(null);
    const endDate = moment().subtract(21, 'years');
    const maxDate = ref(new Date(endDate.unix() * 1000));
    const showSelfieUpload = ref(false);
    const showDateSelect = ref(false);
    const smsDisabled = computed(() => {
      return form.phone.length < 10;
    });
    const registerDisabled = computed(() => {
      // return form.phone.length < 10 || form.password.length < 6 || form.verifyCode.length < 6 || !/^[A-Za-z ]{4,64}$/.test(form.fullName) || !form.birthdayTimestamp || !form.selfieImg;
      return form.phone.length < 10 || form.password.length < 6 || form.verifyCode.length < 6 || !/^[A-Za-z0-9]{6,12}$/.test(form.password);
    });
    onUnmounted(() => {
      if (coldDownInterval.value) {
        clearInterval(coldDownInterval.value);
      }
    });
    const coldDown = () => {
      if (coldDownInterval.value) {
        clearInterval(coldDownInterval.value);
      }
      coldDownInterval.value = setInterval(() => {
        coldDownTime.value = coldDownTime.value - 1;
        if (coldDownTime.value === 0) {
          clearInterval(coldDownInterval.value);
        }
      }, 1000);
    };
    const sendVerifyCode = () => {
      if (smsDisabled.value) {
        return false;
      }
      registerOTP({
        phone: form.phone,
        areaCode: '63'
      }).then(res => {
        coldDownTime.value = 60;
        coldDown();
      });
    };
    const doRegister = () => {
      register({
        phone: form.phone,
        password: md5(form.password),
        areaCode: '63',
        verifyCode: form.verifyCode
        // fullName: form.fullName,
        // birthdayTimestamp: form.birthdayTimestamp || undefined,
        // selfieImg: form.selfieImg
      }).then(res => {
        MyToast({
          type: 'success',
          message: t('notify.registerSuccess')
        });
        let userData = res.data || {};
        userStore.setUserInfo(userData);
        userStore.setLoginInit(true);
        ws.connect();
        useFBQ().registerEvent('CompleteRegistration');
        router.push({
          name: 'game'
        });
      });
    };
    const inputBlur = e => {
      let field = e.target.name;
      if (field) {
        form[field] = form[field].replace(/ +/g, '');
      }
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_popup, {
        show: true,
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('common.register')), 1), _withDirectives(_createVNode(_component_van_image, {
          class: "close-icon",
          src: require('@/assets/img/common/popup-close.png'),
          onClick: _cache[0] || (_cache[0] = $event => emit('onClose'))
        }, null, 8, ["src"]), [[_directive_audio, void 0, "close"]])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_form, {
          class: "input-form style1",
          onSubmit: doRegister
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_van_image, {
            class: "input-icon",
            fit: "contain",
            src: require('@/assets/img/user/form/phone.png')
          }, null, 8, ["src"]), _hoisted_8]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_van_field, {
            modelValue: form.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.phone = $event),
            name: "phone",
            class: "input-field",
            placeholder: _ctx.$t('placeholder.registerPhone'),
            type: "digit",
            onBlur: inputBlur,
            maxlength: "10",
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_van_image, {
            class: "input-icon",
            fit: "contain",
            src: require('@/assets/img/user/form/lock.png')
          }, null, 8, ["src"]), _createVNode(_component_van_field, {
            modelValue: form.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.password = $event),
            name: "password",
            class: "input-field",
            placeholder: _ctx.$t('placeholder.password'),
            type: !showPassword.value ? 'password' : 'text',
            onBlur: inputBlur,
            maxlength: "12",
            clearable: ""
          }, null, 8, ["modelValue", "placeholder", "type"]), _createElementVNode("div", _hoisted_12, [_withDirectives(_createVNode(_component_van_icon, {
            class: "eye-icon",
            name: !showPassword.value ? 'eye-o' : 'closed-eye',
            onClick: _cache[3] || (_cache[3] = $event => showPassword.value = !showPassword.value)
          }, null, 8, ["name"]), [[_directive_audio]])])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_van_image, {
            class: "input-icon",
            fit: "contain",
            src: require('@/assets/img/user/form/key.png')
          }, null, 8, ["src"]), _createVNode(_component_van_field, {
            modelValue: form.verifyCode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.verifyCode = $event),
            name: "verifyCode",
            class: "input-field",
            placeholder: _ctx.$t('placeholder.otp'),
            type: "digit",
            onBlur: inputBlur,
            maxlength: "6",
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"]), coldDownTime.value === 0 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(`sms-btn ${smsDisabled.value ? 'disabled' : ''}`),
            onClick: sendVerifyCode
          }, _toDisplayString(_ctx.$t('common.send')), 3)) : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('common.smsColdDown')) + " " + _toDisplayString(coldDownTime.value) + _toDisplayString(_ctx.$t('common.second')), 1))])]), _withDirectives((_openBlock(), _createBlock(_component_van_button, {
            "native-type": "submit",
            class: "submit-btn",
            block: "",
            disabled: registerDisabled.value
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.register')), 1)]),
            _: 1
          }, 8, ["disabled"])), [[_directive_audio]])]),
          _: 1
        })])])]),
        _: 1
      })]), showDateSelect.value ? (_openBlock(), _createBlock(DateSelect, {
        key: 0,
        modelValue: form.birthdayTimestamp,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.birthdayTimestamp = $event),
        max: maxDate.value,
        onOnClose: _cache[6] || (_cache[6] = $event => showDateSelect.value = false)
      }, null, 8, ["modelValue", "max"])) : _createCommentVNode("", true), showSelfieUpload.value ? (_openBlock(), _createBlock(_unref(UploadId), {
        key: 1,
        modelValue: form.selfieImg,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.selfieImg = $event),
        onOnClose: _cache[8] || (_cache[8] = $event => showSelfieUpload.value = false)
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]);
    };
  }
};